// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer--MXtus","footerLinks":"Footer-module__footerLinks--KfMDH"};